import React, {FC} from "react";
import {Grid} from "@material-ui/core";
import {useField} from "formik";
import {DatePicker, TimePicker} from "@material-ui/pickers";
import {getDate, getHours, getMinutes, getMonth, getYear, set} from "date-fns";

export const CreateOrderTimeFormElement: FC<{}> = () => {

    const [, estimatedFromMeta, estimatedFromHelpers] = useField<number>("estimatedFrom");
    const [, estimatedToMeta, estimatedToHelpers] = useField<number>("estimatedTo");

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <DatePicker
                    cancelLabel={"Zurück"}
                    error={estimatedFromMeta.touched && Boolean(estimatedFromMeta.error)}
                    helperText={estimatedFromMeta.touched && estimatedFromMeta.error}
                    label={"Datum"}
                    fullWidth
                    disablePast={true}
                    format={'dd.MM.yyyy - HH:mm'}
                    value={estimatedFromMeta.value}
                    onChange={(date) => {
                        if (date) {
                            estimatedFromHelpers.setValue(
                                set(
                                    estimatedFromMeta.value ?? date,
                                    {year: getYear(date), month: getMonth(date), date: getDate(date)}
                                ).getTime());
                            estimatedToHelpers.setValue(
                                set(
                                    estimatedToMeta.value ?? date,
                                    {year: getYear(date), month: getMonth(date),  date: getDate(date)}
                                ).getTime())
                        }
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <TimePicker
                    cancelLabel={"Zurück"}
                    error={estimatedFromMeta.touched && Boolean(estimatedFromMeta.error)}
                    helperText={estimatedFromMeta.touched && estimatedFromMeta.error}
                    label={"Von"}
                    fullWidth
                    minutesStep={15}
                    ampm={false}
                    format={"HH:mm"}
                    value={estimatedFromMeta.value}
                    onChange={(date) => {
                        if (date instanceof Date && !isNaN(date.getTime())) {
                            estimatedFromHelpers.setValue(
                                set(
                                    estimatedFromMeta.value ?? date,
                                    {hours: getHours(date), minutes: getMinutes(date)}
                                ).getTime()
                            )
                        }
                    }}
                />
            </Grid>
            <Grid item xs={6}>
                <TimePicker
                    cancelLabel={"Zurück"}
                    error={estimatedToMeta.touched && Boolean(estimatedToMeta.error)}
                    helperText={estimatedToMeta.touched && estimatedToMeta.error}
                    label={"Bis"}
                    fullWidth
                    minutesStep={15}
                    ampm={false}
                    format={"HH:mm"}
                    value={estimatedToMeta.value}
                    onChange={(date) => {
                        if (date instanceof Date && !isNaN(date.getTime())) {
                            estimatedToHelpers.setValue(
                                set(
                                    estimatedToMeta.value ?? date,
                                    {hours: getHours(date), minutes: getMinutes(date)}
                                ).getTime()
                            )
                        }
                    }}
                />
            </Grid>
        </React.Fragment>
    )
}
